import {
  grid_styles_default
} from "./chunk.34WKVTXY.js";
import {
  gridColAlignmentValues,
  gridColOffsetValues,
  gridColValues
} from "./chunk.ZOZHZXHN.js";
import {
  updateBreakpointClasses
} from "./chunk.JI3RRLCG.js";
import {
  SpacePropertyConverter,
  spaceSizes
} from "./chunk.5JHTBFE5.js";
import {
  createBreakpointConverter
} from "./chunk.MIOPVZYG.js";
import {
  watch
} from "./chunk.UW2NVD5N.js";
import {
  applyExternalStyles
} from "./chunk.UFU6LZT7.js";
import {
  e,
  n
} from "./chunk.D5EJUUKV.js";
import {
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/grid/grid.ts
var FadvGrid = class extends s {
  connectedCallback() {
    super.connectedCallback();
    applyExternalStyles(this, grid_styles_default);
  }
  firstUpdated() {
    this.classList.add("container-fluid");
    this.updateGutterClasses(void 0, this.gutter);
  }
  createRenderRoot() {
    return this;
  }
  updateGutterClasses(oldValue, newValue) {
    updateBreakpointClasses(this, "gutter", spaceSizes, oldValue, newValue);
  }
};
__decorateClass([
  e({ converter: SpacePropertyConverter })
], FadvGrid.prototype, "gutter", 2);
__decorateClass([
  watch("gutter", { waitUntilFirstUpdate: true })
], FadvGrid.prototype, "updateGutterClasses", 1);
FadvGrid = __decorateClass([
  n("fadv-grid")
], FadvGrid);
var FadvGridRow = class extends HTMLElement {
  connectedCallback() {
    this.classList.add("row");
  }
};
FadvGridRow = __decorateClass([
  n("fadv-grid-row")
], FadvGridRow);
var FadvGridCol = class extends s {
  constructor() {
    super(...arguments);
    this.colClassnameFormatter = (_p, _k, n2, b) => {
      if (b) {
        if (n2 === "hidden")
          return `d-${b}-none`;
        if (b === "xs")
          return `col-${n2}`;
        return `col-${b}-${n2}`;
      }
      if (n2 === "hidden")
        return "d-none";
      return `col-${n2}`;
    };
    this.classnameFormatter = (_p, k, n2, b) => {
      if (b && b !== "xs") {
        return `${k}-${b}-${n2}`;
      }
      return `${k}-${n2}`;
    };
  }
  handleColChange(oldCol, newCol) {
    updateBreakpointClasses(this, "col", gridColValues, oldCol, newCol, this.colClassnameFormatter);
  }
  handleOffsetChange(oldOffset, newOffset) {
    updateBreakpointClasses(this, "offset", gridColOffsetValues, oldOffset, newOffset, this.classnameFormatter);
  }
  handleAlignmentChange(oldAlignment, newAlignment) {
    updateBreakpointClasses(this, "alignment", gridColAlignmentValues, oldAlignment, newAlignment, this.classnameFormatter);
  }
  firstUpdated() {
    this.classList.add("col");
    this.handleColChange(void 0, this.col);
    this.handleOffsetChange(void 0, this.offset);
    this.handleAlignmentChange(void 0, this.alignment);
  }
  createRenderRoot() {
    return this;
  }
};
__decorateClass([
  e({ converter: createBreakpointConverter(gridColValues) })
], FadvGridCol.prototype, "col", 2);
__decorateClass([
  e({ converter: createBreakpointConverter(gridColOffsetValues) })
], FadvGridCol.prototype, "offset", 2);
__decorateClass([
  e({ converter: createBreakpointConverter(gridColAlignmentValues) })
], FadvGridCol.prototype, "alignment", 2);
__decorateClass([
  watch("col", { waitUntilFirstUpdate: true })
], FadvGridCol.prototype, "handleColChange", 1);
__decorateClass([
  watch("offset", { waitUntilFirstUpdate: true })
], FadvGridCol.prototype, "handleOffsetChange", 1);
__decorateClass([
  watch("alignment", { waitUntilFirstUpdate: true })
], FadvGridCol.prototype, "handleAlignmentChange", 1);
FadvGridCol = __decorateClass([
  n("fadv-grid-col")
], FadvGridCol);

export {
  FadvGrid,
  FadvGridRow,
  FadvGridCol
};
